import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { maintenance } from "src/app/support/maintenance";
import { UserBackend } from "../backend/api/user.backend";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { ErrorCodes } from "../modules/maintenance/error-codes";
import { lastValueFrom } from "rxjs";

@Injectable()
export class ProvideMemberGuard {
  constructor(
    private router: Router,
    private userBackend: UserBackend,
    private bootstrapService: BootstrapService
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      const member = await lastValueFrom(this.userBackend.loadMemberMe());

      if (member) {
        this.bootstrapService.setCurrentMember(member);
        return true;
      } else {
        failure(this.router);
        return false;
      }
    } catch (ex) {
      failure(this.router);
      return false;
    }
  }
}

function failure(router: Router): boolean {
  maintenance(router, { code: ErrorCodes.ERR_003 });

  return false;
}
